export const masonryPhotoGridBreakpoints = {
  default: 6,
  2560: 5,
  1920: 4,
  1280: 3,
  768: 2,
  640: 2
};